<script lang="ts">
  export let name: "prev" | "next" = "prev";
  export let size: "small" | "medium" | "large" = "medium";
  let iconSize: 16 | 24 | 32;
  switch (size) {
    case "small":
      iconSize = 16;
      break;
    case "medium":
      iconSize = 24;
      break;
    case "large":
      iconSize = 32;
      break;
  }

</script>

{#if name === "prev"}
  <button on:click class="fizz-carousel-prev" {...$$restProps}>
    <svg
      fill="currentColor"
      width={iconSize}
      height={iconSize}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5466 9.88L18.6666 8L10.6666 16L18.6666 24L20.5466 22.12L14.44 16L20.5466 9.88Z"
      />
    </svg>
  </button>
{:else if name === "next"}
  <button on:click class="fizz-carousel-next" {...$$restProps}>
    <svg
      fill="currentColor"
      width={iconSize}
      height={iconSize}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M13.3331 8L11.4531 9.88L17.5598 16L11.4531 22.12L13.3331 24L21.3331 16L13.3331 8Z" />
    </svg>
  </button>
{/if}
